export const DEMO_TENANT_SLUG = 'demo';

export function isDemoTenant(slug: string): boolean {
  return slug === DEMO_TENANT_SLUG;
}
